import Markdown from 'components/markdown';
import { IBlogPostFields } from 'global';
import renderDocument from 'modules/content-cms/util/render-document';
import Breadcrumb from 'modules/magazine/common/breadcrumb';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { formatDate, getMagazineUrl } from '../../../magazine/util';
import Image from '../components/image';
import ArticleSchemaMarkup from './article-schema-markup';

const BlogPost: React.FC<IBlogPostFields> = (props) => {
  const { locale } = useRouter();
  const {
    author,
    blogImage,
    description,
    body,
    publishDate,
    showTableOfContents,
    title,
    mainCategory,
    subCategory,
    handle,
  } = props;

  const tableOfContent = body.content.filter((v) => v.nodeType === 'heading-2');

  return (<>
    <ArticleSchemaMarkup
      author={author}
      body={body}
      mainCategory={mainCategory}
      subCategory={subCategory}
      handle={handle}
      title={title}
      publishDate={publishDate}
    />
    <section data-test="blog-post" className="container lg:relative lg:py-10">
      <div className="flex flex-col lg:flex-row lg:gap-8">
        <div className="top-0 lg:sticky lg:w-1/3">
          <div className="flex flex-col text-primary-main ">
            <div className="text-grey flex pb-2 pt-4 font-medium lg:pt-0">
              <Breadcrumb
                mainCategory={props.mainCategory.fields}
                subCategory={props.subCategory.fields}
                blogPost={props}
              />
            </div>
            <h1 className="mb-2 mt-2 text-2xl font-black text-primary-main lg:mb-0 lg:text-3xl">
              {title}
            </h1>
            <div className="-mx-4 my-2 lg:hidden">
              <Image
                className="lg:rounded-xl"
                data-test="blog-image"
                layout={'responsive'}
                objectFit={'cover'}
                priority
                {...blogImage}
              />
            </div>
            <Markdown>{renderDocument(description)}</Markdown>
            <div className="mt-2 font-black text-primary-main lg:mt-12">
              {formatDate(publishDate)}
            </div>
            {showTableOfContents && tableOfContent.length > 0 && (
              <div className="mr-8 mt-4 flex flex-col border-b border-t border-primary-main pb-2 pt-6 text-sm font-black">
                <div className="mb-2">Inhaltsverzeichnis</div>
                <ol style={{ listStyleType: 'decimal' }} className="pl-4">
                  {tableOfContent.map((v) => {
                    if (v.content[0].nodeType !== 'text') {
                      return null;
                    }
                    return (
                      <li
                        className="cursor-pointer pb-2 underline"
                        key={`${v.content[0].value}`}
                      >
                        <a href={`#${v.content[0].value}`}>
                          {v.content[0].value}
                        </a>
                      </li>
                    );
                  })}
                </ol>
              </div>
            )}
          </div>
        </div>
        <article className="flex flex-col text-primary-main lg:w-2/3">
          <div className="hidden lg:block">
            <Image
              className="lg:rounded-xl"
              data-test="blog-image"
              layout={'responsive'}
              objectFit={'cover'}
              {...blogImage}
            />
          </div>
          <div className="mt-4">
            <Markdown>{renderDocument(body)}</Markdown>
          </div>
          <Link
            href={getMagazineUrl(
              {
                author: author.fields,
              },
              false,
              locale
            )}
          >

            <div className={'cursor-pointer'}>
              <div className="flex py-4">
                <div className="w-24 ">
                  <Image
                    className="rounded-lg"
                    data-test="author-image"
                    layout="responsive"
                    {...author.fields.image}
                  />
                </div>

                <div className="py-2 pl-2 font-black text-primary-main">
                  {author.fields.name}
                </div>
              </div>
            </div>

          </Link>
        </article>
      </div>
    </section>
  </>);
};

export default BlogPost;
